import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { useLanguage } from '../contexts/LanguageContext'
import { MANAGE_PRODUCT_PHOTOS_PATH } from '../config/routes'
import config from '../config/config'
import { AuthContext } from '../contexts/AuthContext'
import { setFlashMessage } from '../contexts/WebsiteContext'

import {
  getTranslatedLabel,
  getTranslatedDescription,
} from '../utils/getTranslations'
import { slugify } from '../utils/utils'

import OthersPhotos from '../components/OthersPhotos'
import MainPhoto from '../components/MainPhoto'
import ProductAddToCart from '../components/ProductAddToCart'
import ProductOptions from '../components/Shop/ProductOptions'
import PageHeroTitle from '../components/PageHeroTitle'

const ShopProduct = () => {
  const { t } = useTranslation()
  const { activeLanguage } = useLanguage()
  const { id } = useParams()
  const [product, setProduct] = useState(null)
  const { isAdmin } = useContext(AuthContext)

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}product/${id}`)
        setProduct(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
      }
    }

    fetchProduct()
  }, [id, t])

  useEffect(() => {
    if (product) {
      document.title = getTranslatedLabel(product, activeLanguage)
    }
  }, [product, activeLanguage])

  return (
    <div>
      <NavigationBar />

      {product && (
        <PageHeroTitle
          title={getTranslatedLabel(product, activeLanguage)}
          description=""
        />
      )}

      {product && (
        <div>
          <div className="p-3">
            {isAdmin && (
              <Link
                to={MANAGE_PRODUCT_PHOTOS_PATH.replace(
                  ':slug',
                  slugify(product.labelFr),
                ).replace(':id', product.id)}
                className="btn btn-primary"
                style={{ margin: '10px' }}
              >
                {t('MANAGE_PHOTOS')}
              </Link>
            )}

            <MainPhoto item={product} canBuy={false} />
            <div className="container section">
              <p className="lead">
                {getTranslatedDescription(product, activeLanguage)}
              </p>
            </div>
            <p style={{ textAlign: 'center' }}>
              <ProductAddToCart product={product} t={t} />
            </p>

            <hr />
            <ProductOptions variants={product.productVariants} />

            <OthersPhotos item={product} canBuy={false} />
          </div>
        </div>
      )}
      <Footer />
    </div>
  )
}

export default ShopProduct
